'use strict';

/**
 * Created by jcrid01 on 7/20/15.
 */
var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {
    get: function get(params) {
        //pull query string values out of params to POST with
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().bootstrapProfile, qs, {});
    },
    getCSO: function getCSO(params) {
        //pull query string values out of params to POST with
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().bootstrapCSO, qs, params);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/bootstrapProfileClient.js
// module id = 772
// module chunks = 0